"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Origin = void 0;
var Origin;
(function (Origin) {
    Origin["CHROME_EXTENSION"] = "chrome_extension";
    Origin["MAYDAY_WEB"] = "mayday_web";
    Origin["ADMIN"] = "admin";
    Origin["ZENDESK_APP"] = "zendesk_app";
    Origin["WEB_PARAMETRIC"] = "web_parametric";
    Origin["ADMIN_SERVICE"] = "admin_service";
    Origin["AUTH_SERVICE"] = "auth_service";
    Origin["MAYDAY_WIDGET"] = "mayday_widget";
    Origin["MAYDAY_SELFCARE"] = "mayday_selfcare";
    Origin["SLACK_APP"] = "slack_app";
    Origin["ADMIN_ROUTINE"] = "admin_routine";
    Origin["CONTEXT_SERVICE"] = "context_service";
    // AUTH-SPECIFIC
    Origin["NO_ORIGIN"] = "no_origin";
    Origin["UNKNOWN"] = "unknown";
})(Origin = exports.Origin || (exports.Origin = {}));
